/*
 * @Author: wangshengqiang
 * @Date: 2021-02-08 10:02:54
 * @LastEditTime: 2021-08-04 17:58:44
 * @LastEditors: wangshengqiang
 * @Description:
 */
import { Toast } from 'zarm';
import { createBrowserHistory } from 'history'; // 组件有多种打包方式，这里采用懒实例化的方式

let history = null;

function createHistory(basename = '/') {
  const _history = createBrowserHistory({
    basename
  });

  _history.listen(() => {
    Toast.hide();
    window.scrollTo(0, 0);
  });

  return _history;
}

export function getHistory(basename) {
  if (!history) {
    history = createHistory(basename);
  }

  return history;
}

function proxyFn(fn) {
  return (...args) => {
    return getHistory()[fn](...args);
  };
}

export default {
  push: proxyFn('push'),
  replace: proxyFn('replace'),
  go: proxyFn('go'),
  goBack: proxyFn('goBack'),
  goForward: proxyFn('goForward'),
  listen: proxyFn('listen')
};